<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="section-gap">
        <div class="block">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="链接广告位管理" name="first">
              <div class="block width-1 fleft">
                <router-link :to="{ name: 'cyzsEditAd',}">
                  <span class="button is-success">新增</span>
                </router-link>
              </div>
              <div v-if="adData.count > 0" class="clearfix" >
                <el-pagination
                  @current-change="PAGINATION_CHANGED_EVENT"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="adData.count"
                  class="fright">
                </el-pagination>
              </div>
              <div class="ad-list-container">
                <table class="table is-bordered">
                  <thead>
                  <tr>
                    <td>广告ID</td>
                    <td>广告位banner</td>
                    <td>标题</td>
                    <td>开放时间</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="list-cell" v-for="(item,index) in adData.adList">
                    <td>
                      {{item.adId}}
                      <span class="tag is-success" v-if="item.statusTag==0">开放中</span>
                      <span class="tag is-black" v-if="item.statusTag==1">未开始</span>
                      <span class="tag is-light" v-if="item.statusTag==2">已结束</span>
                      <span class="tag is-light" v-if="item.statusTag==3">已关闭</span>
                    </td>
                    <td>
                      <image-component v-if="item.image.image" :image="item.image" :width="300"></image-component>
                    </td>
                    <td>
                      <p class="title white-space">{{item.title}}</p>
                      <p>
                        <router-link :to="{ name: 'cyzsEditAd', query: { adId:item.adId}}">
                          <span class="button is-info">编辑</span>
                        </router-link>
                        <span class="button is-danger" @click="deleteMainAd(item.adId,index)">删除</span>
                      </p>
                    </td>
                    <td>
                      <p class="time">{{formatDate(item.startTime)}} <span v-if="item.startTime !== 0">~</span> {{formatDate(item.endTime)}} </p>
                      <p class="button is-danger" v-if="item.status == 0">关闭中</p>
                      <p class="button is-success" v-if="item.status == 1">展示中</p>
                      <div class="sort-wrap">排序号</br>
                        <input class="input width-1" v-model="item.sort" @change="sortChange(item.adId,item.sort)">
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="adData.count > 0" class="clearfix">
                <el-pagination
                  @current-change="PAGINATION_CHANGED_EVENT"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="adData.count"
                  class="fright">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="模块设置" name="second">
              <div class="ad-set-module-container">
                <p class="title">模块名称</p>
                <input class="block input width-3" v-model="setModule.title">
                <p class="title">显示状态</p>
                <div class="block">
                  <input type="radio" value="1" v-model="setModuleStatus"><label>永久开启</label>
                  <input type="radio" value="0" v-model="setModuleStatus"><label>永久关闭</label>
                  <input type="radio" value="2" v-model="setModuleStatus"><label>定时开关</label>
                </div>
                <div class="block" v-if="setModuleStatus == 2">
                    <span class="inline-block width-2">
                      <el-date-picker
                        v-model="datetimerange"
                        type="datetimerange"
                        placeholder="请选择时间">
                      </el-date-picker>
                    </span>
                </div>
                <div>
                </div>
                <div class="slider-wrap">
                  <p class="title">
                    <span>与上一模块间距（px)</span>
                    <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top-start">
                      <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                    </el-tooltip>
                  </p>
                  <p>
                    <el-slider v-model="setModule.marginTop" :max="400" :show-input="true"></el-slider>
                  </p>
                </div>
                <div class="slider-wrap">
                  <p class="title">
                    <span>左右间距（px）</span>
                    <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top-start">
                      <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                    </el-tooltip>
                  </p>
                  <p>
                    <el-slider v-model="setModule.marginLeft" :max="400" :show-input="true"></el-slider>
                  </p>
                </div>
                <button class="button is-primary" style="margin: 60px 0 40px 0;" @click="saveModuleClick">保存</button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
  import { formatDate } from 'UTILS/date';

  export default {
    data(){
      return{
        //广告位列表
        adData:{
          adList:[],
          count:0,
          page:1
        },
        currentPage: 1,
        pageSize: 10,
        setModuleStatus:1,
        //模块设置
        setModule:{
          title:"",
          status:1,
          marginTop: 96,
          marginLeft: 40,
          startTime:"",
          endTime:""
        },
        datetimerange: [],
        activeName: 'first'
      }
    },
    computed: {
      marginTopPer () {
        return this.setModule.marginTop + 'px'
      },
      marginLeftPer () {
        return this.setModule.marginLeft + 'px'
      }
    },
    mounted() {
      this.getIndexAdList();
      this.getModuleInit();
    },
    methods:{
      PAGINATION_CHANGED_EVENT(value){
        if(this.currentPage !== value) {
          this.currentPage = value;
          this.getIndexAdList();
        }
      },
      formatDate(date) {
        return formatDate(date, "yyyy-MM-dd hh:mm:ss")
      },
      //删除广告位
      deleteMainAd(adId,index){
        if (confirm('是否确定删除?')) {
          let params = {
            type:0,//广告位
            targetId:adId
          }
          HttpRequest.post("/admin.php?method=main.deleteMainAd",params, true).then((response) => {
            if(response.data.success == 1){
              this.adData.adList.splice(index,1);
            }
          });
        }
      },
      //改变排序
      sortChange(adId,sort){
        let params = {
          type:0,//广告位
          sort:sort,
          targetId:adId
        }
        HttpRequest.post("/admin.php?method=main.doSaveSort",params, true).then((response) => {
          if(response.data.success == 1){
            this.$message("修改成功")
          }
        }, (response) => {

        });
      },
      //获取广告位列表
      getIndexAdList(){
        HttpRequest.get("/admin.php?method=main.getAdList", {page:this.currentPage, pageSize: this.pageSize}, true).then((response) => {
          this.adData.adList = response.data.list;
          this.adData.count = response.data.count;
        }, (response) => {

        });
      },
      //获取模块设置数据
      getModuleInit(){
        HttpRequest.get("/admin.php?method=main.getAdModule", {}, true).then((response) => {
          if(response.data.endTime > 0 && response.data.status == 1){
            this.setModuleStatus = 2;
          }else{
            this.setModuleStatus = response.data.status;
          }
          this.setModule = response.data;
          this.setModule.marginTop = response.data.marginTop*2;
          this.setModule.marginLeft = response.data.marginLeft*2;
          this.datetimerange.push(this.formatDate(response.data.startTime))
          this.datetimerange.push(this.formatDate(response.data.endTime))
        }, (response) => {

        });
      },
      //保存模块设置
      saveModuleClick(){
        let params = Object.assign({},this.setModule);
        params.marginTop = params.marginTop/2;
        params.marginLeft = params.marginLeft/2;
        params.startTime = this.datetimerange[0] ? Date.parse(this.datetimerange[0]) / 1000 : "";
        params.endTime = this.datetimerange[1] ? Date.parse(this.datetimerange[1]) / 1000 : "";
        if(this.setModuleStatus == 2){
          if(params.startTime <= 0){
            this.$message('请选择开始时间');
            return
          }
          if(params.endTime <= 0){
            this.$message('请选择结束时间');
            return
          }
        }
        if (this.setModuleStatus == 2) {
          params.status = 1
        } else {
          params.startTime = '';
          params.endTime = '';
          params.status = this.setModuleStatus
        }
        HttpRequest.post("/admin.php?method=main.doSaveAdModule", params, true).then((response) => {
          if (response.data.success == 1) {
            this.$message('保存成功');
          } else {
            this.$message('接口错误,请联系管理员');
          }
        }, (response) => {

        });
      }
    }
  }
</script>
<style lang="less" scoped>
  .ad-list-container{
    .list-cell{
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .ad-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 560px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
  }
  .white-space {
    white-space: normal;
  }
</style>
